import { exists } from '@aboutyou/legacy-shared/src/utils/exists'
import { useTranslation } from 'helpers/hooks/useTranslation'
import React, { FC } from 'react'
import { useService } from 'services/utils/context'
import { usePremiumPageStore } from 'store/context'
import styled from 'styled-components'
import PremiumLandingSection from '../PremiumLandingSection'
import { SectionHeaderPadded } from '../PremiumSectionHeaders'
import BrandGrid from './BrandGrid'
import BrandList from './BrandList'

const Content = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 0 64px;
  margin-bottom: 80px;
`

const BRANDS_FOR_GRID = 11
const MAX_BRAND_FOR_LIST = 31

const PremiumBrandOverview: FC = () => {
  const { t } = useTranslation()
  const brandIds = usePremiumPageStore(store => store.brandIdsForBrandTiles)
  const service = useService()

  const brands = brandIds
    .map(brandId => service.brands.getByBrandId(brandId))
    .filter(exists)

  if (brands.length === 0) {
    return null
  }

  const sectionTitle = t('Premium Brands')
  const brandIdsForGrid = brandIds.slice(0, BRANDS_FOR_GRID)
  const brandIdsForList = brandIds.slice(BRANDS_FOR_GRID, MAX_BRAND_FOR_LIST)

  return (
    <PremiumLandingSection
      sectionTitle={<SectionHeaderPadded title={sectionTitle} />}
    >
      <Content>
        <BrandGrid brandIds={brandIdsForGrid} />
        <BrandList brandIds={brandIdsForList} />
      </Content>
    </PremiumLandingSection>
  )
}

export default PremiumBrandOverview
